/**
 * Make sure to change the size in the CSS as well.
 *
 * @use ../../styles/app-emoji-art.scss
 */

const newArtSize = 0;
const artSize = [ 10, 12, 14, 16 ];


/**
 * Default emoji art.
 *
 * @param {number} artSizeID The art size ID.
 * @return {array}
 */
const defaultEmojiArt = function( artSizeID = 0 ) {

	const size = artSize[ artSizeID ];

	let newArray = [];
	for ( let y = 0; y < size; y++ ) {
		newArray[ y ] = Array( size ).fill( '🟨' );
	}

	return newArray;

};


/**
 * The Reef data object.
 *
 * @type {object}
 * @property {number} height The height of the art.
 * @property {number} width The width of the art.
 * @property {array} art The emoji art.
 * @property {string} currentEmoji The current emoji.
 * @property {number} currentArtSize The current art size ID.
 * @property {string} paletteSearch The search string for the palette.
 * @property {number} backgroundColor The background color ID.
 * @property {string} size The size of the art.
 */
const ninjaData = new Reef(
	null,
	{
		data: {
			height: artSize[ newArtSize ],
			width: artSize[ newArtSize ],
			art: defaultEmojiArt( newArtSize ),
			currentEmoji: '🟪',
			currentArtSize: newArtSize,
			paletteSearch: '',
			backgroundColor: 4,
			size: 'square',
		},
		lagoon: true,
	}
);

